import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config/api.js

const AddOutdoorProduct = () => {
    const [customerName, setCustomerName] = useState('');
    const [productImage, setProductImage] = useState(null);
    const [description, setDescription] = useState('');
    const [receiverName, setReceiverName] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Handle file input change
    const handleFileChange = (event) => {
        setProductImage(event.target.files[0]);
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        // Check if required fields are filled
        if (!customerName || !productImage || !description || !receiverName) {
            setError('All fields are required.');
            return;
        }

        const formData = new FormData();
        formData.append('customer_name', customerName);
        formData.append('product_image', productImage);
        formData.append('description', description);
        formData.append('receiver_name', receiverName);
        formData.append('staff_id', 1);

        fetch(`${BASE_URL}out-word-products`, {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    // Redirect to the list page after successful creation
                    navigate('/OutdoorProductList');
                } else {
                    setError(data.message);
                }
            })
            .catch(error => {
                console.error('Error adding product:', error);
                setError('An error occurred while adding the product.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Out Product</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Out Product Form</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="customerName" className="form-label">Customer Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="customerName"
                                            value={customerName}
                                            onChange={(e) => setCustomerName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="productImage" className="form-label">Product Image</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            id="productImage"
                                            onChange={handleFileChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows="3"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="receiverName" className="form-label">Receiver Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="receiverName"
                                            value={receiverName}
                                            onChange={(e) => setReceiverName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Add Product</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddOutdoorProduct;
